module.exports = __webpack_public_path__ + "static/media/banesco-mobile-logo-color.81c019b2.svg";